import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import EmployeesListModal from './Modals/EmployeesListModal';
import { ENABLE_MODAL_SWIPE_BACK } from '../utils/mobileModalSwipe';

export default function EmployeesMobile({ open, onClose, onOpenUserRights }) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!ENABLE_MODAL_SWIPE_BACK) {
      touchStartX.current = null;
      touchEndX.current = null;
      return;
    }
    if (!touchStartX.current || !touchEndX.current) return;

    const distance = touchStartX.current - touchEndX.current;
    const minSwipeDistance = 50;

    if (distance > minSwipeDistance) {
      onClose();
    }

    touchStartX.current = null;
    touchEndX.current = null;
  };

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 100002, // Выше SidebarNav (100001)
      }}
      {...(ENABLE_MODAL_SWIPE_BACK ? { onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd } : {})}
    >
      <EmployeesListModal open onClose={onClose} isMobile onOpenUserRights={onOpenUserRights} />
    </div>,
    document.body
  );
}
